export default "/assets/not-active-purple.svg";